"use strict";

let ComboBox;

export class Renderer {

    static init (CB) {
    
        ComboBox=CB;
    
    }

    static make(element, a) {
        
        if (element.nextElementSibling&&element.nextElementSibling.matches('.new-combobox')) {
            if (~['reinit', 'reset'].indexOf(a?.toLowerCase?.())) {
                element.nextElementSibling.remove();
            } else {
                Renderer.fit(element.nextElementSibling);
                return;
            }
        }

        let container=document.createElement('div');
        container.classList.add('new-combobox');

        let multicontainer;
        let multiple=element.matches('select')&&element.multiple;

        if (multiple) {

            multicontainer=document.createElement('div');
            multicontainer.classList.add('multi-container'); 
            if (element.matches('.small-tags')) {multicontainer.classList.add('multi-small-tags');}
            

            container.appendChild(multicontainer);
                        
        }

        let incontainer=document.createElement('div');
        incontainer.classList.add('input-container');        
        incontainer.classList.add('custom-combobox');        

        container.appendChild(incontainer);

        let input=document.createElement('input');
        input.type='text';
        input.setAttribute('autocomplete', 'off');
        input.className='form-control input '+(element.matches('.input-sm')?'input-sm ':'')+'custom-combobox-input'+(element.dataset.css ? ' '+element.dataset.css : '');


        incontainer.appendChild(input);

        let ajax=false;

        if ((element.dataset.source||element.dataset.sourceAppend||element.dataset.sourceappend)) {
            ajax=true;
            let reset=document.createElement('span');
            if (!(multiple)) {container.classList.add('combobox-resetable');}
            reset.classList.add('combobox-reset');
            reset.innerHTML='<span class="icon-cross2"></span>';

            incontainer.appendChild(reset);            

        } else if (element.matches('select')) {
            let arrow=document.createElement('span');
            container.classList.add('combobox-select');
            arrow.classList.add('combobox-arrow');
            arrow.innerHTML='<span class="icon-arrow-down2"></span>';

            incontainer.appendChild(arrow);
        }

        let id='autoComplete'+(element.id||element.name?'-'+(element.id||element.name):'');

        try {
            let i=-1;
            while (document.querySelector('#'+id+(~i?'-'+i:''))) {
                i++;
            }
            id=id+(~i?'-'+i:'');
        } catch(e) {};
        
        input.id=id;

        input.value='';

        if (!element.multiple) {
            if (element.matches('select')) {

                let o;
                if (
                    (o=element.querySelector('option[selected]'))
                        ?true
                        :(o=element.querySelector('option'))
                ) {
                    input.value=o.dataset.short||o.innerText||o.value;
                    o.selected=true;
                    o.setAttribute('selected', 'selected');
                };

            } else if (element.value) { 
                input.value=(element.dataset.label||element.dataset.defaultlabel);
            }
        }

        if (element.value&&(input.value||multiple)) {container.classList.add('combobox-has-value');}

        if (multiple) {
                
            for (let i=0, l=element.options.length; i<l; i++) {
                // přebít kraviny, co si zapamatoval prohlížeč a použít to, co je skutečně nastaveno z BE...
                if (element.options[i].matches('[selected]')) {
                    element.options[i].selected=true;
                    element.options[i].setAttribute('selected', 'selected');
                    Renderer.addMultiOption(multicontainer, element, element.options[i].value, element.options[i].dataset.short||element.options[i].innerText);
                } else {
                    element.options[i].selected=false;                    
                    element.options[i].removeAttribute('selected');
                }
                element.options[i].dataset.sequence=i;
            }
        
        }


        element.insertAdjacentElement('afterend', container);

        Renderer.fit(container);
        
    }

    static addMultiOption(multicontainer, target, value, display) {

        let multi=document.createElement('div');
        multi.innerHTML=display;
        multi.innerHTML+='<span class="multioption-reset"><span class="icon-cross2"></span></span>';
        multi.classList.add('multioption');
        if (target.matches('.user-sequence')) {multi.setAttribute('draggable', true);}
        multi.dataset.value=value;
        multicontainer.appendChild(multi);           
        
        Renderer.multiOptionsOverflow(multicontainer);
        
        return multi;
        
    }

    static multiOptionsOverflow(multicontainer) {

        if (!(multicontainer instanceof HTMLElement)) return;

        let e;
        while (e=multicontainer.querySelector('.multi-show-more')) {e.parentNode.removeChild(e);}
        while (e=multicontainer.querySelector('.multioption-hidden')) {e.classList.remove('multioption-hidden');}

        if (multicontainer.scrollHeight>multicontainer.offsetHeight) {
            let more=document.createElement('div');
            more.classList.add('multioption');
            more.classList.add('multi-show-more');
            more.innerHTML='<a>'+ComboBox.jstr('Další')+' (<span class="more-count">0</span>)...</a>';
            multicontainer.appendChild(more);

            while (multicontainer.scrollHeight>multicontainer.offsetHeight) {
                let multi=multicontainer.querySelectorAll('.multioption:not(.multioption-hidden):not(.multi-show-more)');
                if (!multi.length) break;
                multi=multi[multi.length-1];
                multi.classList.add('multioption-hidden');
                multicontainer.querySelector('.more-count').innerText++;
            }
        }
        
    }

    static fit(c) {

        let inp=c.previousElementSibling;
        let combo=c.querySelector('input');

        if (inp&&inp.matches('input, select')) {
            inp.style.display='none';

            if (combo) {
                combo[inp.matches('[disabled]')?'setAttribute':'removeAttribute']('disabled', true);
                combo[inp.matches('[readonly]')?'setAttribute':'removeAttribute']('readonly', true);

                c[inp.matches('[disabled]')?'setAttribute':'removeAttribute']('disabled', true);
                c[inp.matches('[readonly]')?'setAttribute':'removeAttribute']('readonly', true);

                combo.placeholder=inp.dataset.placeholder||inp.getAttribute('placeholder')||ComboBox.jstr('Napište hledaný text...');
                combo.classList[inp.matches('.disabled')||inp.getAttribute('disabled')?'add':'remove']('disabled');
                c.classList[inp.matches('.disabled')||inp.getAttribute('disabled')?'add':'remove']('disabled');
            
                ComboBox.inherit.forEach((inherit)=>{
                    try {
                        if (inp.matches(inherit.rule)) {
                            (Array.isArray(inherit.classList)
                                ?inherit.classList
                                :inherit.classList
                                    ?[inherit.classList]
                                    :[]
                            ).forEach((css)=>combo.classList.add(css));
                            (Array.isArray(inherit.attributes)
                                ?inherit.attributes
                                :inherit.attributes
                                    ?[inherit.attributes]
                                    :[]
                            ).forEach((att)=>combo.setAttribute(att, inp.getAttribute(att)));

                            if (typeof inherit.call == 'function') { try {inherit.call(c);} catch(e) {console.error(e);}  }
                            if (typeof window[inherit.call] == 'function') { try {window[inherit.call](c);} catch(e) {console.error(e);}  }
                        }
                    } catch(e) {console.error(e);}
                })

            }
            
        }
    
    }

    static resize() {
        
        let multi=document.querySelectorAll('.new-combobox .multi-container');
        for (let i=0, l=multi.length; i<l; i++) {
            Renderer.multiOptionsOverflow(multi[i]);
        }
        Renderer.position;
        
    }

    static toggle() {
        
        if (ComboBox.shown) {if (!ComboBox.keyPressed) {Renderer.hide()}} else {Renderer.show()}
        
    }
    
    static animatePosition(timeout=false) {
        if (ComboBox.target) {
            Renderer.scrollTo=ComboBox.inner?ComboBox.inner.scrollTop:0;
            if (ComboBox.multi.querySelector('.multioption.animate-out, .multioption.animate-in')) {
                Renderer.position();
                setTimeout(()=>{
                    Renderer.animatePosition(true);
                }, 25);
            } else {
                Renderer.position();
                setTimeout(()=>{Renderer.scrollTo=null;}, 25);
            }
        }
    }
    
    static position(event) {

            if (ComboBox.multi) { 
/*                let multi=ComboBox.multi;
                clearTimeout(Renderer.overflowTimeout);
                Renderer.overflowTimeout=setTimeout(()=>*/{Renderer.multiOptionsOverflow(ComboBox.multi);} /*, 50); */
            }
        
        if (ComboBox.container&&ComboBox.combo) {

            if (/*ComboBox.inner&&*/ComboBox.multi&&ComboBox.multi.style.maxHeight) {
                ComboBox.multi.removeAttribute('style');
                let rect=ComboBox.combo.getBoundingClientRect();

if (rect.top<0) {ComboBox.combo.scrollIntoView(true);}

                return Renderer.position(event);
            }
            
            //ComboBox.Listener.lockMouse();
            
            ComboBox.container.removeAttribute('style');

            // kvuli chybovym hlaskam pod elementem, tak pocitej pozici search inputu napisto containeru (v nem totiz je potreba generovat chybove hlasky)
            let rect=ComboBox.combo.querySelector('input.custom-combobox-input').getBoundingClientRect();
            
            if ((rect.top+rect.height)<0) {Renderer.hide(); return;}
            if ((rect.left+rect.width)<0) {Renderer.hide(); return;}

            if (rect.top>window.innerHeight) {Renderer.hide(); return;}
            if (rect.left>document.body.clientWidth) {Renderer.hide(); return;}
            
            let offset=10;
            
            let maxWidth=document.body.clientWidth-offset;
            let maxHeight=window.innerHeight;
            
            // vlevo ??
            if ((rect.left+ComboBox.container.offsetWidth)<maxWidth) {
                ComboBox.container.style.left=rect.left+'px';
                ComboBox.container.style.minWidth=rect.width+'px';
            // vpravo?
            } else if ((rect.left+rect.width-ComboBox.container.offsetWidth)>=offset) {
                ComboBox.container.style.left=(rect.left+rect.width-ComboBox.container.offsetWidth)+'px';
                ComboBox.container.style.minWidth=rect.width+'px';
            // na celou šířku?
            } else {
                ComboBox.container.style.maxWidth=(maxWidth-offset)+'px';
                ComboBox.container.style.left=(maxWidth-ComboBox.container.offsetWidth+offset)/2+'px';
            }
            
            
            // dolů?
            if ((rect.top<(maxHeight-rect.top-rect.height))||((maxHeight-rect.top-rect.height)>(Math.min(ComboBox.container.offsetHeight, 200)))) {
                let height=maxHeight-rect.top-rect.height-offset;
                if (height<ComboBox.container.offsetHeight) {ComboBox.container.style.height=height+'px';}
                ComboBox.container.style.top=(rect.top+rect.height)+'px';                
            // nahoru
            } else {
                let height=rect.top-offset;
                if (height<ComboBox.container.offsetHeight) {ComboBox.container.style.height=height+'px';}
                ComboBox.container.style.top=(rect.top-ComboBox.container.offsetHeight)+'px';                
            }

            if (ComboBox.inner) {
                
                if (Renderer.scrollTo) {
                    if (ComboBox.inner.scrollTo) {ComboBox.inner.scrollTo(0, Renderer.scrollTo);}
                    ComboBox.inner.scrollTop=Renderer.scrollTo;
                }     
                    // kvuli ie v try catch, hází to někdy chybu nikdo neví proč....
try{                
                ComboBox.Listener.activate(ComboBox.inner.querySelector('.combobox-option.active')||ComboBox.inner.querySelector('.combobox-option:not(.disabled)'), !ComboBox.shown);
} catch(e) {}

            }

        }

    }
    
    static mark(text) {
        if (!(ComboBox.keyPressed&&ComboBox.target.value)) {return text;}
        let i;
        let ret='';
        let s=ComboBox.target.value;
        let t=text;
        if (typeof s.normalize === 'function') {
            s=s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        }
        if (typeof t.normalize === 'function') {
            t=t.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        }
        let l=s.length;
        while (~(i=t.indexOf(s))) {
            ret+=text.substr(0,i);
            t=t.substr(i);
            text=text.substr(i);
            ret+='<b class="yellow">'+text.substr(0,l)+'</b>';
            t=t.substr(l);
            text=text.substr(l);
        }
        return ret+text;
    }
    
    
    static show() {
        
        ComboBox.container=document.querySelector('.new-combobox-options')||document.createElement('div');
        ComboBox.container.classList.add('new-combobox-options');
        if (ComboBox.input&&ComboBox.input.matches('select')&&ComboBox.input.multiple) {ComboBox.container.classList.add('multioptions');}
        else {ComboBox.container.classList.remove('multioptions');}
        ComboBox.container.innerHTML='';
        document.body.appendChild(ComboBox.container);
        
        ComboBox.container.classList.remove('locked')

        if (Array.isArray(ComboBox.options)&&ComboBox.options.length) {
            ComboBox.inner=document.createElement('div');
            ComboBox.inner.classList.add('combobox-inner');
            ComboBox.container.appendChild(ComboBox.inner);
            
            if (ComboBox.ajax_pending) {ComboBox.container.classList.add('locked')};
// uživatelé jablek si stěžují, že se jim 2000 položek vykresluje dlouho; nehodlám omezovat kvůli tomu všechny == pokud vykresluji déle, než 100ms, ufiknu to...
let t0=performance.now();            
let badPerformance=false;
            ComboBox.options.forEach((o, i)=>{
                if (!badPerformance) {
                    
                    let option=document.createElement('span');
                    option.classList.add('combobox-option');
                    option.innerHTML=o.display||o.value;
                    option.dataset.label=option.innerHTML;
                    option.dataset.short=o.short||"";
                    if (option.innerHTML==option.innerText) {
                        option.innerHTML=Renderer.mark(option.innerHTML);
                    }
                    option.dataset.value=o.value;
                    if (o.disabled) {option.classList.add('disabled');}
                    if (ComboBox.input&&ComboBox.input.multiple&&ComboBox.getOptionAlreadyChecked(o)) {
    /*                    if (ComboBox.input.matches(':not(.user-sequence)')) {
                            option.classList.add('disabled');
                        }*/
                        option.innerHTML='<span class="option-checked"><span class="icon-checkmark"></span></span>'+option.innerHTML;
                    }
                    if ((ComboBox.value===o.value)) {option.classList.add('active');}
                    ComboBox.inner.appendChild(option);

                    if (i&&(!(i%25))) {
                        badPerformance=(performance.now()-t0)>100;
                        if (badPerformance) {
                            console.log('Combobox: bad performance, vykreslono: '+i+' položek.');
                            ComboBox.inner.insertAdjacentHTML('beforeend', '<span class="too-many-results">'+ComboBox.jstr('Příliš mnoho výsledků, upřesněte hledaný výraz.')+'</span>')
                        }
                    }

                }
                
            });
            
            Renderer.position();
            ComboBox.Listener.lockMouse();            
            
        } else { 

            let getmsg=(no, i=0)=>{
                switch(no) {
                    case 0:return ComboBox.jstr('Chyba spojení se serverem');
                    case 1:return ComboBox.ajax_url && ( ComboBox.ajaxMessage!==null ) && ( ComboBox.ajaxMessage!==undefined )
                        ?ComboBox.ajaxMessage
                        :ComboBox.input?.dataset?.emptyResult || ComboBox.jstr('Hledaný výraz nebyl nalezen')
                    ;
                    case 2:return (i==1
                            ?ComboBox.jstr('Zadejte hledaný výraz (min. 1 znak)')
                            :(i>4
                                ?ComboBox.jstr('Zadejte hledaný výraz (min. %s znaků)').replace('%s', i)
                                :ComboBox.jstr('Zadejte hledaný výraz (min. %s znaky)').replace('%s', i)
                            )
                        );
                    case 3:return ComboBox.jstr('Žádné možnosti')
                }
                return '';
            }

            let message=(ComboBox.target&&(ComboBox.target.value.length>=(ComboBox.minLength||0))
                ?(ComboBox.ajax_url
                    ?(ComboBox.ajax_err
                        ?getmsg(0)
                        :(ComboBox.ajax_pending?'':(ComboBox.target.value.length?getmsg(1):getmsg(3)))
                    )
                    :getmsg(1)
                )
                :(ComboBox.ajax_url
                    ?getmsg(2, ComboBox.minLength)
                    :getmsg(3)
                )
            );

            ComboBox.container.innerHTML='<span class="no-results">'+(message)+'</span>'
            Renderer.position();
        }

        ComboBox.shown=true;
    }

    static hide() {
        if (ComboBox.container) {
            if (ComboBox.container.parentNode) {ComboBox.container.parentNode.removeChild(ComboBox.container);}
            ComboBox.container=null;
        }
        ComboBox.inner=null;
        ComboBox.shown=false;        
    }

    static slowScroll(to) {        
        clearInterval(Renderer.slowInterval);
        if (ComboBox.inner) {
            Renderer.slowFrom=ComboBox.inner.scrollTop;
            Renderer.slowTo=to;
            Renderer.slowStep=(Renderer.slowTo-Renderer.slowFrom)/7;
            Renderer.slowStepNo=0;
            Renderer.slowInterval=setInterval(()=>{
                if (ComboBox.inner) {
                    if ( ((ComboBox.inner.scrollTop>Renderer.slowTo)&&(Renderer.slowStep<0)) || ((ComboBox.inner.scrollTop<Renderer.slowTo)&&(Renderer.slowStep>0)) ) {
                        Renderer.slowStepNo++;
                        if (ComboBox.inner.scrollTo) {ComboBox.inner.scrollTo(0, Renderer.slowFrom+Renderer.slowStep*Renderer.slowStepNo);}
                        ComboBox.inner.scrollTop=Renderer.slowFrom+Renderer.slowStep*Renderer.slowStepNo;
                    } else {
                        clearInterval(Renderer.slowInterval);
                    }
                } else {
                    clearInterval(Renderer.slowInterval);
                }
            }, 10);
        }
    }

}